import { render } from "./facilityAgriculture.vue?vue&type=template&id=6c87a404&scoped=true"
const script = {}

import "./facilityAgriculture.vue?vue&type=style&index=0&id=6c87a404&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c87a404"]])

export default __exports__